import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AccessDenied from 'src/components/AccessDenied';
import { useUserContext } from 'src/context/userState/userContext';
import {
  canAccessPath,
  getDefaultHomePath,
  getRoleFromToken,
} from 'src/permissions/roleAccess';

/**
 * Blocks direct URL access to pages the user's role cannot use.
 * API routes remain the source of truth; this improves admin UX only.
 */
export default function RoleRouteGuard({ children }) {
  const location = useLocation();
  const { state } = useUserContext();
  const role = state?.me?.role || getRoleFromToken();
  const pathname = location.pathname;

  if (!role) {
    return children;
  }

  if (pathname === '/' || pathname === '') {
    return <Navigate to={getDefaultHomePath(role)} replace />;
  }

  if (!canAccessPath(pathname, role)) {
    return <AccessDenied />;
  }

  return children;
}
